import { Injectable } from '@angular/core';
import { DatabaseService } from './db-service';
import { environment } from '../../environments/environment';
import { Sport } from '../enums';
import { SportLeague } from '../models';
import { AngularFirestore } from '@angular/fire/firestore';
import { DateService } from './date-service';

@Injectable({
  providedIn: 'root'
})

export class LeagueService {

    public collection: string = 'sportLeagues';

    constructor(
        private angularFirestore: AngularFirestore,
        private databaseService: DatabaseService,
        private dateService: DateService) {
    }

    /**
     * Get Leagues for specific sport
     * @param sport reference of spot enum
     */
    public getLeagueList(sport: Sport, serviceYear: string = environment.serviceYear) {
        return this.databaseService.getDocuments(this.collection, ref => ref
            .where('serviceYear', '==', serviceYear)
            .where('sport', '==', sport)
            .where('isActive', '==', true)
            .where('isDeleted', '==', false)
        );
    }

    // CRUD functions
    // Create
    public async createLeague(league: SportLeague) {
        league.serviceYear = environment.serviceYear;
        this.angularFirestore.collection(this.collection).add(league);
    }

    public async migrateLeague(league: SportLeague, incrementYears: number) {
        league.serviceYear = environment.serviceYear;

        const id = this.angularFirestore.createId();
        league.id = id;
        
        league = {
            ...league,
            openDate: this.dateService.addYears(incrementYears, league.openDate),
            closeDate: this.dateService.addYears(incrementYears, league.closeDate)
        };

        this.angularFirestore
                .collection(this.collection)
                .doc(id)
                .set(league);
    }
}
